<template>
  <div class="x-banner">
    <div class="banner-content">
      <div class="banner-left">
        <div class="banner-icon">
          <i class="fa-brands fa-x-twitter"></i>
        </div>
        <div class="banner-text">
          <h3>{{ t('X_BANNER.title') }}</h3>
          <p>{{ t('X_BANNER.description') }}</p>
        </div>
      </div>
      <a href="https://x.com/skinwhaless" target="_blank" rel="noopener" class="banner-cta">
        <i class="fa-brands fa-x-twitter"></i>
        {{ t('X_BANNER.cta') }}
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped lang="scss">
@use 'sass:color';

.x-banner {
  width: 100%;
  margin: 1em auto;
  max-width: 1500px;

  @media (max-width: 1500px) {
    padding: 0 20px;
  }

  @media (max-width: 768px) {
    padding: 0 1rem;
    margin: 0 auto 1.5rem auto;
  }

  .banner-content {
    gap: 1.5rem;
    background:
      linear-gradient(135deg, rgba($surface, 0.6) 0%, $elevation1 100%),
      radial-gradient(circle at 20% 80%, $elevation2 0%, transparent 70%),
      radial-gradient(circle at 80% 20%, $elevation3 0%, transparent 70%);
    padding: 1.5rem 2rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    border-radius: 8px;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: repeating-linear-gradient(
        -45deg,
        transparent 0px,
        transparent 40px,
        rgba(29, 161, 242, 0.05) 40px,
        rgba(29, 161, 242, 0.05) 80px
      );
      pointer-events: none;
    }

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 1rem;
      padding: 1rem 1.5rem;
      text-align: center;
    }
  }

  .banner-left {
    display: flex;
    align-items: center;
    gap: 1rem;
    z-index: 1;

    @media (max-width: 768px) {
      flex-direction: column;
      gap: 0.5rem;
    }
  }

  .banner-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, $elevation2 0%, $elevation1 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);

    i {
      font-size: 1.5rem;
      color: white;
    }

    @media (max-width: 768px) {
      width: 40px;
      height: 40px;

      i {
        font-size: 1.25rem;
      }
    }
  }

  .banner-text {
    color: white;

    h3 {
      font-size: 1.25rem;
      font-weight: 700;
      margin: 0 0 0.25rem 0;
      color: #ffffff;

      @media (max-width: 768px) {
        font-size: 1.1rem;
      }
    }

    p {
      font-size: 0.9rem;
      margin: 0;
      opacity: 0.8;
      line-height: 1.3;

      @media (max-width: 768px) {
        font-size: 0.8rem;
      }
    }
  }

  .banner-cta {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1.5rem;
    background: linear-gradient(135deg, $elevation2 0%, $elevation1 100%);
    border: 2px solid $elevation2;
    border-radius: 8px;
    color: white;
    text-decoration: none;
    font-weight: 700;
    font-size: 0.9rem;
    transition: all 0.2s ease;
    flex-shrink: 0;
    z-index: 1;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

    &:hover {
      background: linear-gradient(
        135deg,
        color.scale($elevation2, $lightness: 10%) 0%,
        $elevation2 100%
      );
      border-color: color.scale($elevation2, $lightness: 10%);
      box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
    }

    i {
      font-size: 0.9rem;
    }

    @media (max-width: 768px) {
      padding: 0.6rem 1.25rem;
      font-size: 0.8rem;

      i {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
